import Image from 'next/image';
import { components, DropdownIndicatorProps } from 'react-select';
import { GroupBase } from 'react-select/dist/declarations/src/types';

export const CustomDropdownIndicator = <Option, IsMulti extends boolean = false>(
  props: DropdownIndicatorProps<Option, IsMulti, GroupBase<Option>>
) => {
  return (
    <components.DropdownIndicator {...props}>
      <Image src="/assets/images/select-chevron-icon.svg" alt="Chevron" width={20} height={20} />
    </components.DropdownIndicator>
  );
};
